import { CommandTypes } from '../../chat/commands/types';
import { ANDROID_SETTINGS_CONSTANTS, openSystemSettings } from '../functions';

export interface OpenSystemSettingsCommand {
  type: CommandTypes.OPEN_SYSTEM_SETTINGS;

  data: {
    setting?: ANDROID_SETTINGS_CONSTANTS;
  };
}

interface Params {
  command: OpenSystemSettingsCommand;
}

export const openSystemSettingsCommand = ({
  command: {
    data: { setting },
  },
}: Params) => {
  if (setting) {
    openSystemSettings(setting);
  }
};
